import { render, staticRenderFns } from "./BuyTicketsComponent.vue?vue&type=template&id=7a16b58e"
import script from "./BuyTicketsComponent.vue?vue&type=script&lang=js"
export * from "./BuyTicketsComponent.vue?vue&type=script&lang=js"
import style0 from "./BuyTicketsComponent.vue?vue&type=style&index=0&id=7a16b58e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports